(function () {
  'use strict';

  angular.module('app').component('packageDayList', packageDayList());

  function packageDayList() {
    return {
      bindings: {
        items: '=',
        package: '=',
        defaultLanguage: '<',
      },
      controller: PackageDayListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/package-days/package-day-list/package-day-list.component.html',
    };
  }

  PackageDayListComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'PackageDayService'];

  function PackageDayListComponent(config, UtilService, PackageDayService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = PackageDayService.getFilterCriteria();

    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.reorderListEnabled = false;
    vm.sortableOptions = {
      disabled: true,
    };

    // Methods
    vm.addPackageDayDetail = addPackageDayDetail;
    vm.showPackageDayDetail = showPackageDayDetail;
    vm.changePackageDayStatus = changePackageDayStatus;
    vm.deletePackageDay = deletePackageDay;

    vm.editReorderList = editReorderList;
    vm.saveReorderList = saveReorderList;
    vm.cancelEditReorderList = cancelEditReorderList;

    function editReorderList() {
      vm.originalItems = angular.copy(vm.items);

      vm.sortableOptions.disabled = !vm.sortableOptions.disabled;
    }

    function saveReorderList() {
      var successCallback = function (items) {
        vm.items = items;

        vm.sortableOptions.disabled = true;
      };

      PackageDayService.reorderPackageDays(vm.items, vm.package.id, successCallback);
    }

    function cancelEditReorderList() {
      vm.items = vm.originalItems;

      vm.sortableOptions.disabled = true;
    }

    function addPackageDayDetail() {
      var successCallback = function (data) {
        vm.items.push(data);
      };

      PackageDayService.openPackageDayDetailModal(
        {},
        'create',
        vm.defaultLanguage,
        vm.package,
        successCallback
      );
    }

    function showPackageDayDetail(item, mode) {
      if (!vm.sortableOptions.disabled) {
        return;
      }

      PackageDayService.openPackageDayDetailModal(item, mode, vm.defaultLanguage, vm.package);
    }

    function changePackageDayStatus(item) {
      PackageDayService.changePackageDayStatus(item, vm.package.id);
    }

    function deletePackageDay(item, index) {
      var successCallback = function () {
        vm.items.splice(index, 1);
      };

      PackageDayService.deletePackageDay(item, vm.package.id, successCallback);
    }
  }
})();
